import React from 'react';

import UserAvatar from '@/components/UserAvatar/UserAvatar';
import { ModalSectionCard } from '@/components/shared/ModalSectionCard';
import { ModalSectionTitle } from '@/components/shared/ModalSectionTitle';
import { QuartileScales } from '@/components/shared/QuartileScales/QuartileScales';
import { ChartSectionData } from '@/helpers/reportsDataHelpers';
import { AverageSentimentData } from '@/hooks/useReportsData';
import { useAuth } from '@/providers/AuthProvider';

import { ChartEmptyState } from '../ChartEmptyState/ChartEmptyState';

type Props = {
	section: ChartSectionData<AverageSentimentData>;
};

export const AverageSentimentCard: React.FC<Props> = ({ section }) => {
	const { user } = useAuth();

	if (section.emptyReason !== null) {
		return (
			<ModalSectionCard paddingSize="lg">
				<ModalSectionTitle>Average Sentiment</ModalSectionTitle>
				<ChartEmptyState emptyReason={section.emptyReason ?? 'no-history'} />
			</ModalSectionCard>
		);
	}

	const data = section.data[0];
	if (!data) return null;

	const myIndicator = user?.id ? (
		<UserAvatar userId={user.id} size="xxx-small" showActiveStatus={false} />
	) : null;

	return (
		<ModalSectionCard paddingSize="lg">
			<ModalSectionTitle>Average Sentiment</ModalSectionTitle>
			<QuartileScales
				quartiles={data}
				myPersonalScore={data.myPersonalScore}
				myTeamScore={data.myTeamScore}
				myCongregationalScore={data.myCongregationalScore}
				myPersonalIndicator={myIndicator}
			/>
		</ModalSectionCard>
	);
};
